module.exports = __webpack_public_path__ + "src/assets/img/historie_special_en.6b4cfcf3.png";